import React from 'react';
import {Text, View} from 'react-native';

import ButtonComponent from '../ButtonComponent/ButtonComponent';
import {useCommunicationModalStore} from '../../store/CommunicationModalStore';
import {navigate} from '../../navigation/navigationRef';
import {navigateFromRoute} from '../../utils/navigateFromRoute';
import {useFilterStore} from '../../store/FilterStore';
import {styles} from './styles';

// Apenas o conteúdo. O <Modal> é fornecido pelo AppModalHost
// para evitar concorrência de apresentação no iOS.
const CommunicationModal = () => {
  const activeModal = useCommunicationModalStore(state => state.activeModal);
  const dismissActive = useCommunicationModalStore(state => state.dismissActive);
  const {setSelectedCategory, setSelectedBrand} = useFilterStore();

  if (!activeModal) {
    return null;
  }

  const {route, cta_label: ctaLabel, dismiss_label: dismissLabel} = activeModal;
  const hasCta = Boolean(route?.url && ctaLabel);

  // Dispensar já marca como vista, então a modal não volta (CA-02). O
  // AppModalHost fica fora do NavigationContainer, por isso a navegação passa
  // pela navigationRef em vez de useNavigation().
  const handleCtaPress = async () => {
    await dismissActive();
    navigateFromRoute(route, {navigate}, {
      setSelectedCategory,
      setSelectedBrand,
    });
  };

  return (
    <View style={styles.containerModal}>
      <View style={styles.containerCard}>
        <Text style={styles.title}>{activeModal.title}</Text>
        <Text style={styles.body}>{activeModal.body}</Text>
        {hasCta ? (
          <>
            <View style={styles.buttonWrapper}>
              <ButtonComponent
                title={ctaLabel as string}
                width="80%"
                onPress={handleCtaPress}
              />
            </View>
            <View style={styles.secondaryButtonWrapper}>
              <ButtonComponent
                title={dismissLabel || 'Agora não'}
                outlined
                width="80%"
                onPress={dismissActive}
              />
            </View>
          </>
        ) : (
          <View style={styles.buttonWrapper}>
            <ButtonComponent
              title={dismissLabel || 'Entendi!'}
              outlined
              width="80%"
              onPress={dismissActive}
            />
          </View>
        )}
      </View>
    </View>
  );
};

export default CommunicationModal;
